"use strict";

(function () {
  'use strict';

  function setEnv() {
    var hostname = window && window.location && window.location.hostname;

    if (hostname === 'rtm.liverez.com') {
      window.ENVIRONMENT = 'production';
    } else if (hostname === 'stage-rtm.liverez.com') {
      window.ENVIRONMENT = 'stage';
    } else if (/^qa/.test(hostname)) {
      window.ENVIRONMENT = 'qa';
    } else if (/^development/.test(hostname)) {
      window.ENVIRONMENT = 'development';
    } else {
      window.ENVIRONMENT = 'local';
    }
  }

  angular.module('lr.core', ['ngCookies', 'ngTouch', 'lr.core.controller', 'lr.core.routes', 'justGage', 'ui.bootstrap', 'infinite-scroll']).config([function () {
    setEnv(); // google analytics

    if (window.ENVIRONMENT === 'production') {
      var script = document.createElement('script');
      script.innerHTML = "\n          (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){\n                (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n              m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n            })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');\n      \n            ga('create', 'UA-3434724-29', 'auto');\n          ";
      document.head.appendChild(script);
    }
  }]).run(['$rootScope', 'AnalyticsService', function ($rootScope, AnalyticsService) {
    $rootScope.$on('$routeChangeStart', function () {
      $rootScope.$broadcast('toggle-app-close');
    });
    $rootScope.$on('$routeChangeSuccess', function (event, currentRoute) {
      $rootScope.PAGETITLE = currentRoute.title;
      AnalyticsService.pageView(currentRoute.$$route.originalPath);
    }); //GA4 Gtag

    AnalyticsService.getGtag().then(function (response) {
      window.dataLayer = window.dataLayer || [];

      window.gtag = window.gtag || function () {
        window.dataLayer.push(arguments);
      };

      window.gtag('js', new Date());
      window.gtag('config', response.data);
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = '//www.googletagmanager.com/gtag/js?id=' + response.data;
      document.getElementsByTagName('head')[0].appendChild(script);
    }, function (errorResponse) {
      console.log(errorResponse);
    });
  }]);
})();